/**
 * @Author  : Luo
 * @Time    : 2020/4/10 15:44
 * config of message in global
 */

'use strict'

module.exports = {
  // message of internet
  ERR_HTTP_MESSAGE_NO_SIGN_IN: '请先登录！',
  ERR_HTTP_MESSAGE_INVALID: '登录过期，请重新登录！',
  ERR_HTTP_MESSAGE_NO_EXITS: '网络请求不存在！',

  // message of hint
  ERR_PASS: '密码错误！',
  ERR_ACCOUNT: '账号不存在！',
  ERR_PASS_ACCOUNT: '账号或密码不存在',
  ERR_GET_URL: 'url is undefined in axios`s get',
  ERR_POST_URL: 'url is undefined in axios`s post'
}



// WEBPACK FOOTER //
// ./src/message/index.js